import ConsoleLogger from './consoleLogger';
import EventsLogger from './eventsLogger';

export {
    ConsoleLogger,
    EventsLogger,
};

export default {
    ConsoleLogger,
    EventsLogger,
};
